import Toastify from "toastify-js";

export default function initToastify() {
    // Queries Toasts

    document.addEventListener("kobleQuerySaved", (response) => {
        const action = response.detail.action;
        let text = response.detail.message;
        let link = response.detail.link;
        const formElement = document.querySelector("#saveQuery");

        if (formElement) {
            let formLink = formElement.getAttribute("data-message-link");
            let formText = false;
            if (formLink) link = formLink;

            switch (action) {
                case "skip_query":
                    formText = formElement.getAttribute("data-message-exists");
                    if (formText) text = formText;

                    break;

                case "add_query":
                    formText = formElement.getAttribute("data-message-added");
                    if (formText) text = formText;

                    break;

                case "delete_query":
                    formText = formElement.getAttribute("data-message-delete");
                    if (formText) text = formText;

                    break;

                case "error":
                    formText = formElement.getAttribute("data-message-error");
                    if (formText) text = formText;

                    break;
            }
        }

        defaultToastify(text);
    });

    // Activate / Deactivate query alert

    document.addEventListener("kobleQueryAlertActivate", (response) => {
        const action = response.detail;
        const buttonElement = document.querySelector(".activate-alert");
        let messageActivated = "The alert has been activated";
        let messageDeactivate = "The alert has been deactivated";

        if (buttonElement) {
            if (buttonElement.getAttribute("data-message-activate"))
                messageActivated = buttonElement.getAttribute(
                    "data-message-activate"
                );

            if (buttonElement.getAttribute("data-message-deactivate"))
                messageActivated = buttonElement.getAttribute(
                    "data-message-deactivate"
                );
        }

        let text = messageActivated;

        if (response.detail == 0) {
            text = messageDeactivate;
        }

        defaultToastify(text);
    });

    // Delet query alert

    document.addEventListener("kobleQueryDeleted", (response) => {
        const action = response.detail;
        const buttonElement = document.querySelector(".delete-query");
        let text = "The query has been deleted";

        if (buttonElement) {
            if (buttonElement.getAttribute("data-message"))
                text = buttonElement.getAttribute("data-message");
        }

        defaultToastify(text);
    });

    // Favorites toasts

    document.addEventListener("kobleFavoritesAdded", (response) => {
        const action = response.detail.response;
        const buttonElement = document.querySelector(".add-to-favorites");
        let addMessage = "Added to favorites successfully";
        let removedMessage = "Removed from favorites successfully";

        if (buttonElement) {
            if (buttonElement.getAttribute("data-add-title"))
                addMessage = buttonElement.getAttribute("data-add-title");

            if (buttonElement.getAttribute("data-remove-title"))
                removedMessage =
                    buttonElement.getAttribute("data-remove-title");
        }

        let text = addMessage;
        if (action == "removed") text = removedMessage;

        defaultToastify(text);
    });

    function defaultToastify(
        $text,
        $background = "rgba(var(--smoke-rgb), 50%)",
        $color = "black"
    ) {
        Toastify({
            text: $text,
            duration: 3000,
            newWindow: true,
            close: true,
            gravity: "bottom", // `top` or `bottom`
            position: "right", // `left`, `center` or `right`
            stopOnFocus: true, // Prevents dismissing of toast on hover
            escapeMarkup: true,
            style: {
                background: $background,
                color: $color,
            },
        }).showToast();
    }
}
